export default {
  key: 'boucherie',
  label: 'Boucherie',
  theme: {
    primary: '#9d0419',
    secondary: '#e44353',
  },
  sections: {
    plu: true,
    contacts: true,
    employees: true,
    fournisseurs: true,
    plateaux: false,
    etiquettes: false,
    retrocession: false,
    tva: false,
    nettoyage: true,
    pms: true,
  },
}
